module.exports = __webpack_public_path__ + "img/amendiades4.22128a4a.png";